import { UseFormRegister, FieldErrors, RegisterOptions } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { IFormInput } from "./ProgramForm";
import { Flex, Textarea } from "@amzn/ring-ui-react-components";

export interface TextareaProps {
  placeholder: string;
  name: string;
  register: UseFormRegister<IFormInput>;
  validations: RegisterOptions<IFormInput, string> | undefined;
  errors: FieldErrors<IFormInput>;
}

export const FormTextarea = (props: TextareaProps) => {
  const textAreaStyles = {
    width: "100%",
    height: "125px",
    padding: "25px 15px",
    marginRight: "30px",
  };
  return (
    <Flex
      style={{
        width: "100%",
        marginBottom: "15px",
        paddingRight: "30px",
        flexDirection: "column",
      }}
    >
      <Textarea
        style={textAreaStyles}
        placeholder={props.placeholder}
        {...props.register(props.name, props.validations)}
      />
      <ErrorMessage
        style={{ color: "#ff0000" }}
        errors={props.errors}
        name={props.name}
        as="span"
      />
    </Flex>
  );
};
